import axiosInstance from './axiosInstance';

const loggingService = {
  log: (message, data) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[LOG] ${message}`, data || '');
    }
  },

  error: (message, error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(`[ERROR] ${message}`, error || '');
    }
  },

  warn: (message, data) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[WARN] ${message}`, data || '');
    }
  },

  logActivity: async (activityData) => {
    try {
      loggingService.log('Activity:', activityData);
      // For now, just log to console. You can add API endpoint later if needed
      return true;
    } catch (error) {
      loggingService.error('Failed to log activity:', error);
      return false;
    }
  }
};

export default loggingService;